<div class="card bg-blue-100 p-4">
    <p class="f-small">
        <span class="fw-semibold">{{boldedText}} </span> 
        <span>{{text}}</span>
    </p>
</div>
